/**
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiDELETE, apiGET, apiGETPaginated, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Gets all the existing tasks according to provided filters, with pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getTasksPaginated(filters) {
    return await apiGETPaginated('/api/tasks', filters);
}

/**
 * Returns the existing tasks according to provided filters, without pagination.
 *
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function getTasks() {
    return await apiGET('/api/tasks');
}

/**
 * Creates a new task with the provided information.
 *
 * @param task
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createTask(task) {
    return await apiPOST('/api/task', task);
}

/**
 * Updates the provided task with the new values.
 *
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 * @param task
 */
export async function updateTask(task) {
    return await apiPUT('/api/task/' + task.id, task);
}

/**
 * Updates the requested task with the provided status.
 *
 * @param task_id
 * @param data
 * @returns {Promise<T|AxiosResponse<*>|*|null>}
 */
export async function updateTaskStatus(task_id, data) {
    return await apiPUT('/api/task/' + task_id +'/change-status', data);
}

/**
 * Deletes the provided task
 *
 * @param task
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteTask(task) {
    return await apiDELETE('/api/task/' + task.id);
}
